import makeRequest from '#shared/util/makeRequest.js';

/**
 * Validate email address domain
 * @param {string} domain Domain of the email address
 * @returns {Promise}
 */
const isEmailDomain = async function(domain) {
	try {
		const response = await makeRequest.post('/api/v1/cart/validate/email', {
			credentials: 'same-origin',
			json: {
				value: domain
			}
		});
		return response.body.data;
	} catch (error) {
		if (error.app && error.app.status === 401) {
			return this.$store.commit('SET_ERROR', error);
		} else {
			throw error;
		}
	}
};

/**
 * Export the Vue plugin install method
 * @param {object} Vue Vue instance
 */
export const install = (Vue) => {
	Vue.prototype.isEmailDomain = isEmailDomain;
};

export default {
	install
};
